const createMapCursorElevationController = function ({
  $ = window.jQuery,
  fnGetMap = function () { return null },
  db = {},
  store = {},
  baseSwal = window.Swal,
  fnT = function (key) { return String(key || '') },
  fnTF = function (_key, vars) {
    const from = (vars && typeof vars === 'object') ? vars.from : ''
    const to = (vars && typeof vars === 'object') ? vars.to : ''
    return String(from || '') + ' -> ' + String(to || '')
  },
  fnIsDemProviderEnabled = function () { return true },
  DEM_PROVIDER_CONFIG = {},
  DEM_CURSOR_PROVIDER_PRIORITY = [],
  DEM_PROVIDER_PRIORITY = [],
  DEM_PROVIDER_G = 'gDEM',
  MAP_CURSOR_ELEVATION_CACHE_MAX = 500,
  MAP_CURSOR_ELEVATION_COORD_DECIMALS = 4,
  MAP_CURSOR_ELEVATION_MIN_REQUEST_INTERVAL_MS = 250,
  toFiniteNumber = function (value) {
    const n = Number(value)
    return Number.isFinite(n) ? n : null
  },
  fnFetchSurfaceElevationByProvider = async function () { return [] },
} = {}) {
  const LOCAL_TERRAIN_STATE_KEY = 'PORTAL_LOCAL_TERRAIN_STATE'
  const LOCAL_DEM_PROVIDER_KEY = 'localDEM'
  const mapCursorElevationCacheMax = Math.max(1, Number(MAP_CURSOR_ELEVATION_CACHE_MAX || 500))
  const mapCursorElevationCoordDecimals = Math.max(0, Number(MAP_CURSOR_ELEVATION_COORD_DECIMALS || 4))
  const mapCursorElevationMinRequestIntervalMs = Math.max(0, Number(MAP_CURSOR_ELEVATION_MIN_REQUEST_INTERVAL_MS || 250))
  let sessionShowRemoteCursorElevation = true

  const state = {
    $badge: null,
    pendingLatLng: null,
    pendingContainerPoint: null,
    requestTimer: null,
    inFlight: false,
    lastRequestAt: 0,
    cache: new Map(),
    isVisible: false,
    pointerInside: false,
    initialized: false,
    lastAltitudeCharCount: 0,
    pendingLocalElevation: null
  }

  const escapeHtmlLite = function (raw) {
    return String(raw === null || raw === undefined ? '' : raw)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
  }

  const isLatLngInsidePolygon = function (lat, lng, polygonLatLngs) {
    const testLat = Number(lat)
    const testLng = Number(lng)
    if (!Number.isFinite(testLat) || !Number.isFinite(testLng)) return false
    const polygon = Array.isArray(polygonLatLngs) ? polygonLatLngs : []
    if (polygon.length < 3) return false
    let inside = false
    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      const rowI = polygon[i]
      const rowJ = polygon[j]
      if (!Array.isArray(rowI) || rowI.length < 2 || !Array.isArray(rowJ) || rowJ.length < 2) continue
      const yi = Number(rowI[0])
      const xi = Number(rowI[1])
      const yj = Number(rowJ[0])
      const xj = Number(rowJ[1])
      if (!Number.isFinite(yi) || !Number.isFinite(xi) || !Number.isFinite(yj) || !Number.isFinite(xj)) continue
      const intersects = ((yi > testLat) !== (yj > testLat)) &&
        (testLng < ((xj - xi) * (testLat - yi) / ((yj - yi) || 1e-12)) + xi)
      if (intersects) inside = !inside
    }
    return inside
  }

  const hasLocalTerrainSampler = function (localState) {
    return !!(
      localState &&
      localState.active === true &&
      (
        typeof localState.sampleElevation === 'function' ||
        typeof localState.sampleElevationAsync === 'function' ||
        typeof localState.sampleElevations === 'function'
      )
    )
  }

  const isLocalProviderActive = function () {
    if (typeof window === 'undefined') return false
    const localState = window[LOCAL_TERRAIN_STATE_KEY]
    return hasLocalTerrainSampler(localState)
  }

  const isProviderAvailable = function (providerKey) {
    const key = String(providerKey || '').trim()
    if (!key) return false
    if (key === LOCAL_DEM_PROVIDER_KEY) return isLocalProviderActive()
    return fnIsDemProviderEnabled(key)
  }

  const getDemProviderLabel = function (providerKey) {
    if (String(providerKey || '').trim() === LOCAL_DEM_PROVIDER_KEY) return 'Local DEM/DSM'
    const cfg = DEM_PROVIDER_CONFIG[providerKey]
    if (!cfg || !cfg.label) return providerKey
    const accuracy = String(cfg.accuracy || '').trim()
    return accuracy ? (cfg.label + ' (' + accuracy + ')') : cfg.label
  }

  const normalizeMapCursorElevationSettings = function (options) {
    const opts = Object.assign({ persist: false }, options || {})
    if (!db.settings || typeof db.settings !== 'object') db.settings = {}
    if (!db.settings.mapCursorElevation || typeof db.settings.mapCursorElevation !== 'object') {
      db.settings.mapCursorElevation = {}
    }
    let changed = false
    if (!Object.prototype.hasOwnProperty.call(db.settings.mapCursorElevation, 'showLocalCursorElevation')) {
      db.settings.mapCursorElevation.showLocalCursorElevation = true
      changed = true
    } else {
      const normalizedLocalVisibility = db.settings.mapCursorElevation.showLocalCursorElevation !== false
      if (db.settings.mapCursorElevation.showLocalCursorElevation !== normalizedLocalVisibility) {
        db.settings.mapCursorElevation.showLocalCursorElevation = normalizedLocalVisibility
        changed = true
      }
    }
    if (!Object.prototype.hasOwnProperty.call(db.settings.mapCursorElevation, 'snapToGridEnabled')) {
      db.settings.mapCursorElevation.snapToGridEnabled = true
      changed = true
    } else {
      const normalizedGridSnapEnabled = db.settings.mapCursorElevation.snapToGridEnabled !== false
      if (db.settings.mapCursorElevation.snapToGridEnabled !== normalizedGridSnapEnabled) {
        db.settings.mapCursorElevation.snapToGridEnabled = normalizedGridSnapEnabled
        changed = true
      }
    }
    if (Object.prototype.hasOwnProperty.call(db.settings.mapCursorElevation, 'showRemoteCursorElevation')) {
      delete db.settings.mapCursorElevation.showRemoteCursorElevation
      changed = true
    }
    if (changed && opts.persist !== false && store && typeof store.setAll === 'function') {
      void store.setAll(db)
    }
    return db.settings.mapCursorElevation
  }

  const ensureMapCursorElevationSettings = function () {
    return normalizeMapCursorElevationSettings({ persist: false })
  }

  const getShowRemoteCursorElevation = function () {
    return sessionShowRemoteCursorElevation === true
  }

  const getShowLocalCursorElevation = function () {
    const mapCursorElevationSettings = ensureMapCursorElevationSettings()
    return mapCursorElevationSettings.showLocalCursorElevation !== false
  }

  const getGridSnapEnabled = function () {
    const mapCursorElevationSettings = ensureMapCursorElevationSettings()
    return mapCursorElevationSettings.snapToGridEnabled !== false
  }

  const clearPendingLookup = function () {
    state.pendingLatLng = null
    state.pendingContainerPoint = null
    state.pendingLocalElevation = null
    if (state.requestTimer) {
      clearTimeout(state.requestTimer)
      state.requestTimer = null
    }
  }

  const syncCursorDisplayGlobals = function () {
    if (typeof window === 'undefined') return
    window.PORTAL_MAP_CURSOR_ELEVATION_REMOTE_ENABLED = getShowRemoteCursorElevation() ? '1' : '0'
    window.PORTAL_MAP_CURSOR_ELEVATION_LOCAL_ENABLED = getShowLocalCursorElevation() ? '1' : '0'
    window.PORTAL_MAP_CURSOR_ELEVATION_GRID_SNAP_ENABLED = getGridSnapEnabled() ? '1' : '0'
  }

  const syncPointerVisibilityState = function () {
    if (getShowRemoteCursorElevation() || getShowLocalCursorElevation()) return
    clearPendingLookup()
    setBadgeVisible(false)
  }

  const setShowRemoteCursorElevation = function (enabled, _options) {
    sessionShowRemoteCursorElevation = (enabled === true)
    if (state.cache) state.cache.clear()
    syncCursorDisplayGlobals()
    syncPointerVisibilityState()
    return sessionShowRemoteCursorElevation
  }

  const setShowLocalCursorElevation = function (enabled, options) {
    const opts = Object.assign({ persist: true }, options || {})
    const mapCursorElevationSettings = ensureMapCursorElevationSettings()
    mapCursorElevationSettings.showLocalCursorElevation = (enabled !== false)
    if (state.cache) state.cache.clear()
    syncCursorDisplayGlobals()
    syncPointerVisibilityState()
    if (opts.persist !== false && store && typeof store.setAll === 'function') {
      void store.setAll(db)
    }
    return mapCursorElevationSettings.showLocalCursorElevation
  }

  const setGridSnapEnabled = function (enabled, options) {
    const opts = Object.assign({ persist: true }, options || {})
    const mapCursorElevationSettings = ensureMapCursorElevationSettings()
    mapCursorElevationSettings.snapToGridEnabled = (enabled !== false)
    syncCursorDisplayGlobals()
    if (opts.persist !== false && store && typeof store.setAll === 'function') {
      void store.setAll(db)
    }
    return mapCursorElevationSettings.snapToGridEnabled
  }

  const getFirstAvailableNonLocalProvider = function () {
    const candidates = []
      .concat(Array.isArray(DEM_CURSOR_PROVIDER_PRIORITY) ? DEM_CURSOR_PROVIDER_PRIORITY : [])
      .concat(Array.isArray(DEM_PROVIDER_PRIORITY) ? DEM_PROVIDER_PRIORITY : [])
      .concat(Object.keys(DEM_PROVIDER_CONFIG || {}))
      .concat([DEM_PROVIDER_G])
    const seen = {}
    for (let i = 0; i < candidates.length; i++) {
      const key = String(candidates[i] || '').trim()
      if (!key || key === LOCAL_DEM_PROVIDER_KEY) continue
      if (seen[key]) continue
      seen[key] = true
      if (isProviderAvailable(key)) return key
    }
    return ''
  }

  const normalizeFallbackProvider = function (candidateProvider, primaryProvider) {
    const preferred = String(candidateProvider || '').trim()
    if (preferred && preferred !== LOCAL_DEM_PROVIDER_KEY && isProviderAvailable(preferred)) return preferred
    const primary = String(primaryProvider || '').trim()
    if (primary && primary !== LOCAL_DEM_PROVIDER_KEY && isProviderAvailable(primary)) return primary
    const nonLocal = getFirstAvailableNonLocalProvider()
    if (nonLocal) return nonLocal
    if (primary && isProviderAvailable(primary)) return primary
    return DEM_PROVIDER_G
  }

  const syncFallbackProviderGlobals = function (providerKey) {
    if (typeof window === 'undefined') return
    window.PORTAL_MAP_CURSOR_ELEVATION_FALLBACK_PROVIDER = String(providerKey || '').trim()
  }

  const registerFallbackProviderGlobals = function () {
    if (typeof window === 'undefined') return
    window.PORTAL_GET_MAP_CURSOR_ELEVATION_FALLBACK_PROVIDER = getFallbackProvider
    window.PORTAL_SET_MAP_CURSOR_ELEVATION_FALLBACK_PROVIDER = setFallbackProvider
    window.PORTAL_GET_MAP_CURSOR_ELEVATION_REMOTE_ENABLED = getShowRemoteCursorElevation
    window.PORTAL_SET_MAP_CURSOR_ELEVATION_REMOTE_ENABLED = setShowRemoteCursorElevation
    window.PORTAL_GET_MAP_CURSOR_ELEVATION_LOCAL_ENABLED = getShowLocalCursorElevation
    window.PORTAL_SET_MAP_CURSOR_ELEVATION_LOCAL_ENABLED = setShowLocalCursorElevation
    window.PORTAL_GET_MAP_CURSOR_ELEVATION_GRID_SNAP_ENABLED = getGridSnapEnabled
    window.PORTAL_SET_MAP_CURSOR_ELEVATION_GRID_SNAP_ENABLED = setGridSnapEnabled
    syncFallbackProviderGlobals(getFallbackProvider())
    syncCursorDisplayGlobals()
  }

  const getProvider = function () {
    const raw = String((db && db.settings && db.settings.mapCursorElevation && db.settings.mapCursorElevation.provider) || '').trim()
    if (raw && isProviderAvailable(raw)) return raw
    if (isLocalProviderActive()) return LOCAL_DEM_PROVIDER_KEY
    const fallback = DEM_CURSOR_PROVIDER_PRIORITY.find(function (providerKey) { return isProviderAvailable(providerKey) })
    return fallback || DEM_PROVIDER_PRIORITY[0] || DEM_PROVIDER_G
  }

  const getFallbackProvider = function () {
    const mapCursorElevationSettings = ensureMapCursorElevationSettings()
    const primaryProvider = getProvider()
    const raw = String(mapCursorElevationSettings.fallbackProvider || '').trim()
    const normalized = normalizeFallbackProvider(raw, primaryProvider)
    mapCursorElevationSettings.fallbackProvider = normalized
    syncFallbackProviderGlobals(normalized)
    return normalized
  }

  const setFallbackProvider = function (providerKey, options) {
    const opts = Object.assign({ persist: true }, options || {})
    const mapCursorElevationSettings = ensureMapCursorElevationSettings()
    const primaryProvider = getProvider()
    const normalized = normalizeFallbackProvider(providerKey, primaryProvider)
    mapCursorElevationSettings.fallbackProvider = normalized
    syncFallbackProviderGlobals(normalized)
    if (opts.persist !== false && store && typeof store.setAll === 'function') {
      void store.setAll(db)
    }
    return normalized
  }

  const setProvider = function (providerKey, options) {
    const opts = Object.assign({
      showToast: false,
      fromProvider: '',
      persist: true,
      fallbackProvider: undefined,
      syncFallbackWithPrimary: false
    }, options || {})
    const normalized = isProviderAvailable(providerKey) ? providerKey : getProvider()
    const mapCursorElevationSettings = ensureMapCursorElevationSettings()
    const previous = String(opts.fromProvider || mapCursorElevationSettings.provider || '').trim()
    mapCursorElevationSettings.provider = normalized
    const shouldSyncFallbackWithPrimary = !!opts.syncFallbackWithPrimary
    const requestedFallbackProvider = String(opts.fallbackProvider || '').trim()
    if (requestedFallbackProvider || shouldSyncFallbackWithPrimary || !String(mapCursorElevationSettings.fallbackProvider || '').trim()) {
      const fallbackTarget = requestedFallbackProvider || (shouldSyncFallbackWithPrimary ? normalized : mapCursorElevationSettings.fallbackProvider)
      mapCursorElevationSettings.fallbackProvider = normalizeFallbackProvider(fallbackTarget, normalized)
    }
    syncFallbackProviderGlobals(mapCursorElevationSettings.fallbackProvider)
    if (state.cache) state.cache.clear()
    if (opts.persist !== false && store && typeof store.setAll === 'function') {
      void store.setAll(db)
    }
    if (opts.showToast && previous && previous !== normalized && baseSwal && typeof baseSwal.fire === 'function') {
      baseSwal.fire({
        toast: true,
        position: 'bottom-end',
        icon: 'warning',
        title: fnT('map_elevation.provider_switched_title'),
        text: fnTF('map_elevation.provider_switched_text', {
          from: getDemProviderLabel(previous),
          to: getDemProviderLabel(normalized)
        }),
        timer: 4200,
        timerProgressBar: true,
        showConfirmButton: false
      })
    }
    return normalized
  }

  const buildTryOrder = function (primaryProvider, options) {
    const opts = Object.assign({
      includeLocalFirst: true,
      includeLocalProvider: true
    }, options || {})
    const allowLocalProvider = opts.includeLocalProvider !== false && isLocalProviderActive()
    const first = isProviderAvailable(primaryProvider) ? primaryProvider : getProvider()
    const combined = (opts.includeLocalFirst && allowLocalProvider ? [LOCAL_DEM_PROVIDER_KEY] : [])
      .concat([first])
      .concat(DEM_CURSOR_PROVIDER_PRIORITY)
      .concat(Object.keys(DEM_PROVIDER_CONFIG || {}))
    const seen = {}
    return combined.filter(function (providerKey) {
      const key = String(providerKey || '').trim()
      if (key === LOCAL_DEM_PROVIDER_KEY && !allowLocalProvider) return false
      if (!key || !isProviderAvailable(key)) return false
      if (seen[key]) return false
      seen[key] = true
      return true
    })
  }

  const roundCoord = function (value) {
    const n = Number(value)
    if (!Number.isFinite(n)) return null
    const factor = Math.pow(10, mapCursorElevationCoordDecimals)
    return Math.round(n * factor) / factor
  }

  const buildCacheKey = function (providerKey, latlng) {
    const lat = roundCoord(latlng && latlng.lat)
    const lng = roundCoord(latlng && latlng.lng)
    if (lat === null || lng === null) return ''
    return String(providerKey || '').trim() + ':' + lat.toFixed(mapCursorElevationCoordDecimals) + ',' + lng.toFixed(mapCursorElevationCoordDecimals)
  }

  const getFromCache = function (providerKey, latlng) {
    const cacheKey = buildCacheKey(providerKey, latlng)
    if (!cacheKey || !state.cache) return null
    if (!state.cache.has(cacheKey)) return null
    const cached = Number(state.cache.get(cacheKey))
    if (!Number.isFinite(cached)) return null
    return cached
  }

  const setCache = function (providerKey, latlng, elevation) {
    const cacheKey = buildCacheKey(providerKey, latlng)
    const value = Number(elevation)
    if (!cacheKey || !Number.isFinite(value) || !state.cache) return
    state.cache.set(cacheKey, value)
    while (state.cache.size > mapCursorElevationCacheMax) {
      const firstKey = state.cache.keys().next().value
      if (!firstKey) break
      state.cache.delete(firstKey)
    }
  }

  const ensureBadge = function () {
    if (state.$badge && state.$badge.length) return state.$badge
    const map = fnGetMap()
    if (!map || typeof map.getContainer !== 'function') return null
    const host = map.getContainer()
    if (!host || !$) return null
    const $badge = $('<div class="portal-cursor-elevation-badge"></div>').text(fnT('map_elevation.cursor_loading'))
    $(host).append($badge)
    state.$badge = $badge
    return $badge
  }

  const setBadgeVisible = function (visible) {
    const $badge = ensureBadge()
    if (!$badge || !$badge.length) return
    const isVisible = !!visible
    state.isVisible = isVisible
    $badge.toggleClass('is-visible', isVisible)
  }

  const positionBadge = function (containerPoint) {
    const $badge = ensureBadge()
    const map = fnGetMap()
    if (!$badge || !$badge.length || !map || !containerPoint) return
    const host = map.getContainer()
    if (!host) return
    const hostWidth = Number(host.clientWidth || 0)
    const hostHeight = Number(host.clientHeight || 0)
    let x = Number(containerPoint.x) + 20
    let y = Number(containerPoint.y) + 20
    const badgeWidth = Number($badge.outerWidth() || 200)
    const badgeHeight = Number($badge.outerHeight() || 30)
    if (Number.isFinite(hostWidth) && hostWidth > 0) {
      x = Math.max(4, Math.min(x, hostWidth - badgeWidth - 4))
    }
    if (Number.isFinite(hostHeight) && hostHeight > 0) {
      y = Math.max(4, Math.min(y, hostHeight - badgeHeight - 4))
    }
    $badge.css({ left: x + 'px', top: y + 'px' })
  }

  const renderLoading = function (containerPoint) {
    const $badge = ensureBadge()
    if (!$badge || !$badge.length) return
    $badge.removeClass('is-error is-local-terrain').addClass('is-loading')
    const count = Math.max(1, Number(state.lastAltitudeCharCount || 0))
    $badge.text('$'.repeat(count) + ' m')
    setBadgeVisible(true)
    positionBadge(containerPoint)
  }

  const renderValue = function (_providerKey, elevation, containerPoint, options) {
    const $badge = ensureBadge()
    if (!$badge || !$badge.length) return
    const opts = Object.assign({ fromLocalTerrain: false }, options || {})
    const rounded = Math.round(Number(elevation) * 10) / 10
    const elevationText = Number.isFinite(rounded) ? String(Math.round(rounded)) : String(elevation)
    state.lastAltitudeCharCount = Math.max(1, elevationText.length)
    $badge.removeClass('is-loading is-error')
    $badge.toggleClass('is-local-terrain', !!opts.fromLocalTerrain)
    $badge.text(elevationText + ' m')
    setBadgeVisible(true)
    positionBadge(containerPoint)
  }

  const renderLocalAndFallbackValue = function (localElevation, fallbackElevation, containerPoint, options) {
    const $badge = ensureBadge()
    if (!$badge || !$badge.length) return
    const opts = Object.assign({ fallbackLoading: false }, options || {})
    const localNumeric = toFiniteNumber(localElevation)
    const fallbackNumeric = toFiniteNumber(fallbackElevation)
    const localRounded = Number.isFinite(localNumeric) ? (Math.round(localNumeric * 10) / 10) : null
    const fallbackRounded = Number.isFinite(fallbackNumeric) ? (Math.round(fallbackNumeric * 10) / 10) : null
    const localText = Number.isFinite(localRounded) ? (String(Math.round(localRounded)) + ' m') : '--'
    const fallbackText = Number.isFinite(fallbackRounded)
      ? (String(Math.round(fallbackRounded)) + ' m')
      : (opts.fallbackLoading ? ('$'.repeat(Math.max(1, Number(state.lastAltitudeCharCount || 0))) + ' m') : '--')
    state.lastAltitudeCharCount = Math.max(1, localText.replace(/[^\d-]/g, '').length)
    $badge.removeClass('is-loading is-error is-local-terrain')
    $badge.html(
      '<span class="portal-cursor-elevation-badge__line portal-cursor-elevation-badge__line--local">' + escapeHtmlLite(localText) + '</span>' +
      '<span class="portal-cursor-elevation-badge__line portal-cursor-elevation-badge__line--fallback">' + escapeHtmlLite(fallbackText) + '</span>'
    )
    setBadgeVisible(true)
    positionBadge(containerPoint)
  }

  const renderError = function (containerPoint, message) {
    const $badge = ensureBadge()
    if (!$badge || !$badge.length) return
    $badge.removeClass('is-loading is-local-terrain').addClass('is-error')
    $badge.text(String(message || fnT('map_elevation.cursor_error')))
    setBadgeVisible(true)
    positionBadge(containerPoint)
  }

  const isLatLngInsideLocalTerrain = function (localState, latlng) {
    if (!latlng || !localState) return false
    const lat = Number(latlng.lat)
    const lng = Number(latlng.lng)
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return false
    if (typeof localState.containsLatLng === 'function') {
      return localState.containsLatLng(lat, lng) === true
    }
    const footprint = Array.isArray(localState.footprintLatLngs) ? localState.footprintLatLngs : []
    if (footprint.length >= 3) {
      return isLatLngInsidePolygon(lat, lng, footprint)
    }
    return true
  }

  const sampleLocalTerrainElevationSync = function (latlng) {
    if (!latlng) return null
    if (typeof window === 'undefined') return null
    const localState = window[LOCAL_TERRAIN_STATE_KEY]
    if (!hasLocalTerrainSampler(localState) || typeof localState.sampleElevation !== 'function') return null
    if (!isLatLngInsideLocalTerrain(localState, latlng)) return null
    const lat = Number(latlng.lat)
    const lng = Number(latlng.lng)
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null
    return toFiniteNumber(localState.sampleElevation(lat, lng))
  }

  const sampleLocalTerrainElevationAsync = async function (latlng, options) {
    const opts = Object.assign({ syncValue: null }, options || {})
    const forcedValue = toFiniteNumber(opts.syncValue)
    if (forcedValue !== null) return forcedValue
    if (!latlng || typeof window === 'undefined') return null
    const localState = window[LOCAL_TERRAIN_STATE_KEY]
    if (!hasLocalTerrainSampler(localState)) return null
    if (!isLatLngInsideLocalTerrain(localState, latlng)) return null
    const lat = Number(latlng.lat)
    const lng = Number(latlng.lng)
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null
    try {
      if (typeof localState.sampleElevationAsync === 'function') {
        return toFiniteNumber(await localState.sampleElevationAsync(lat, lng, { resampling: 'nearest' }))
      }
      if (typeof localState.sampleElevations === 'function') {
        const sampledValues = await localState.sampleElevations([{ lat: lat, lng: lng }], { resampling: 'nearest' })
        return toFiniteNumber(sampledValues && sampledValues[0])
      }
      if (typeof localState.sampleElevation === 'function') {
        return toFiniteNumber(localState.sampleElevation(lat, lng))
      }
    } catch (_error) {
      return null
    }
    return null
  }

  const fetchWithFallback = async function (latlng, localElevationOverride, options) {
    const opts = Object.assign({
      allowRemoteValues: true,
      allowLocalValues: true
    }, options || {})
    const allowRemoteValues = opts.allowRemoteValues !== false
    const allowLocalValues = opts.allowLocalValues !== false
    if (!allowRemoteValues && !allowLocalValues) {
      return { ok: false, suppressed: true }
    }
    const startProvider = getProvider()
    const localElevation = allowLocalValues
      ? await sampleLocalTerrainElevationAsync(latlng, { syncValue: localElevationOverride })
      : null
    if (localElevation !== null) {
      if (!allowRemoteValues) {
        return {
          ok: true,
          provider: LOCAL_DEM_PROVIDER_KEY,
          elevation: localElevation,
          localElevation: localElevation,
          fromLocalTerrain: true,
          remoteSuppressed: true
        }
      }
      const fallbackProvider = getFallbackProvider()
      const providers = buildTryOrder(fallbackProvider, {
        includeLocalFirst: false,
        includeLocalProvider: false
      })
      for (let i = 0; i < providers.length; i++) {
        const providerKey = providers[i]
        const cached = getFromCache(providerKey, latlng)
        if (Number.isFinite(cached)) {
          return {
            ok: true,
            provider: providerKey,
            elevation: cached,
            localElevation: localElevation,
            fromLocalTerrain: true
          }
        }
        try {
          const elevations = await fnFetchSurfaceElevationByProvider(providerKey, [latlng])
          const elevation = toFiniteNumber(elevations && elevations[0])
          if (elevation === null) continue
          const rounded = Math.round(elevation * 10) / 10
          setCache(providerKey, latlng, rounded)
          return {
            ok: true,
            provider: providerKey,
            elevation: rounded,
            localElevation: localElevation,
            fromLocalTerrain: true
          }
        } catch (_error) {}
      }
      return {
        ok: true,
        provider: fallbackProvider,
        elevation: null,
        localElevation: localElevation,
        fromLocalTerrain: true
      }
    }
    if (!allowRemoteValues) {
      return { ok: false, suppressed: true }
    }
    const startsFromLocalProvider = (startProvider === LOCAL_DEM_PROVIDER_KEY)
    const firstLookupProvider = startsFromLocalProvider ? getFallbackProvider() : startProvider
    const providers = buildTryOrder(firstLookupProvider, {
      includeLocalFirst: (!startsFromLocalProvider && allowLocalValues),
      includeLocalProvider: allowLocalValues
    })
    let firstError = ''
    for (let i = 0; i < providers.length; i++) {
      const providerKey = providers[i]
      const cached = getFromCache(providerKey, latlng)
      if (Number.isFinite(cached)) {
        if (!startsFromLocalProvider && providerKey !== startProvider) {
          setProvider(providerKey, {
            showToast: true,
            fromProvider: startProvider
          })
        }
        return { ok: true, provider: providerKey, elevation: cached, fromLocalTerrain: false }
      }
      try {
        const elevations = await fnFetchSurfaceElevationByProvider(providerKey, [latlng])
        const elevation = toFiniteNumber(elevations && elevations[0])
        if (elevation === null) throw new Error(fnT('dem.request_failed'))
        const rounded = Math.round(elevation * 10) / 10
        setCache(providerKey, latlng, rounded)
        if (!startsFromLocalProvider && providerKey !== startProvider) {
          setProvider(providerKey, {
            showToast: true,
            fromProvider: startProvider
          })
        }
        return { ok: true, provider: providerKey, elevation: rounded, fromLocalTerrain: false }
      } catch (error) {
        if (!firstError) {
          firstError = String((error && error.message) || fnT('dem.request_failed'))
        }
      }
    }
    return {
      ok: false,
      provider: startProvider,
      error: firstError || fnT('map_elevation.cursor_error')
    }
  }

  const scheduleLookup = function () {
    if (!state.pendingLatLng) return
    if (state.requestTimer || state.inFlight) return
    const elapsed = Date.now() - Number(state.lastRequestAt || 0)
    const waitMs = Math.max(0, mapCursorElevationMinRequestIntervalMs - elapsed)
    state.requestTimer = setTimeout(function () {
      state.requestTimer = null
      void runLookup()
    }, waitMs)
  }

  const runLookup = async function () {
    if (state.inFlight) return
    const latlng = state.pendingLatLng
    const containerPoint = state.pendingContainerPoint
    const localElevationOverride = state.pendingLocalElevation
    if (!latlng) return
    state.pendingLatLng = null
    state.pendingContainerPoint = null
    state.pendingLocalElevation = null
    state.inFlight = true
    state.lastRequestAt = Date.now()
    try {
      const result = await fetchWithFallback(latlng, localElevationOverride, {
        allowRemoteValues: getShowRemoteCursorElevation(),
        allowLocalValues: getShowLocalCursorElevation()
      })
      if (state.pointerInside) {
        if (result && result.suppressed) {
          setBadgeVisible(false)
          return
        }
        if (result && result.ok) {
          if (result.fromLocalTerrain) {
            const showRemoteValues = getShowRemoteCursorElevation()
            const showLocalValues = getShowLocalCursorElevation()
            if (showLocalValues && !showRemoteValues) {
              renderValue(result.provider, result.localElevation, containerPoint, { fromLocalTerrain: true })
            } else if (!showLocalValues && showRemoteValues && Number.isFinite(toFiniteNumber(result.elevation))) {
              renderValue(result.provider, result.elevation, containerPoint, { fromLocalTerrain: false })
            } else if (showLocalValues) {
              if (result.remoteSuppressed === true) {
                renderValue(result.provider, result.localElevation, containerPoint, { fromLocalTerrain: true })
              } else {
                renderLocalAndFallbackValue(result.localElevation, result.elevation, containerPoint, { fallbackLoading: false })
              }
            } else {
              setBadgeVisible(false)
            }
          } else {
            if (getShowRemoteCursorElevation()) {
              renderValue(result.provider, result.elevation, containerPoint, { fromLocalTerrain: false })
            } else {
              setBadgeVisible(false)
            }
          }
        } else {
          renderError(containerPoint, fnT('map_elevation.cursor_error'))
        }
      }
    } catch (_error) {
      if (state.pointerInside) {
        renderError(containerPoint, fnT('map_elevation.cursor_error'))
      }
    } finally {
      state.inFlight = false
      if (state.pendingLatLng) {
        scheduleLookup()
      }
    }
  }

  const initTracking = function () {
    const map = fnGetMap()
    if (state.initialized) return
    if (!map || typeof map.on !== 'function' || typeof map.getContainer !== 'function') return
    const host = map.getContainer()
    if (!host) return
    state.initialized = true
    ensureBadge()
    map.on('mousemove', function (event) {
      const latlng = event && event.latlng ? event.latlng : null
      const containerPoint = event && event.containerPoint ? event.containerPoint : null
      if (!latlng || !containerPoint) return
      const showRemoteValues = getShowRemoteCursorElevation()
      const showLocalValues = getShowLocalCursorElevation()
      state.pointerInside = true
      if (!showRemoteValues && !showLocalValues) {
        clearPendingLookup()
        setBadgeVisible(false)
        return
      }
      state.pendingLatLng = { lat: Number(latlng.lat), lng: Number(latlng.lng) }
      state.pendingContainerPoint = { x: Number(containerPoint.x), y: Number(containerPoint.y) }
      const localProviderActive = showLocalValues && isLocalProviderActive()
      const localElevation = showLocalValues ? sampleLocalTerrainElevationSync(state.pendingLatLng) : null
      if (localElevation !== null) {
        state.pendingLocalElevation = localElevation
        if (!showRemoteValues) {
          renderValue(LOCAL_DEM_PROVIDER_KEY, localElevation, containerPoint, {
            fromLocalTerrain: true
          })
          return
        }
        renderLocalAndFallbackValue(localElevation, null, containerPoint, {
          fallbackLoading: true
        })
        scheduleLookup()
        return
      }
      if (localProviderActive && !showRemoteValues) {
        state.pendingLocalElevation = null
        renderLoading(state.pendingContainerPoint)
        scheduleLookup()
        return
      }
      state.pendingLocalElevation = null
      if (!showRemoteValues) {
        clearPendingLookup()
        setBadgeVisible(false)
        return
      }
      const activeProvider = getProvider()
      const cacheProvider = (activeProvider === LOCAL_DEM_PROVIDER_KEY) ? getFallbackProvider() : activeProvider
      const cached = getFromCache(cacheProvider, state.pendingLatLng)
      if (Number.isFinite(cached)) {
        renderValue(activeProvider, cached, state.pendingContainerPoint, { fromLocalTerrain: false })
      } else {
        renderLoading(state.pendingContainerPoint)
      }
      scheduleLookup()
    })
    host.addEventListener('mouseleave', function () {
      state.pointerInside = false
      state.pendingLatLng = null
      state.pendingContainerPoint = null
      state.pendingLocalElevation = null
      if (state.requestTimer) {
        clearTimeout(state.requestTimer)
        state.requestTimer = null
      }
      setBadgeVisible(false)
    })
    registerFallbackProviderGlobals()
  }

  normalizeMapCursorElevationSettings({ persist: true })
  registerFallbackProviderGlobals()

  return {
    getDemProviderLabel: getDemProviderLabel,
    getProvider: getProvider,
    getFallbackProvider: getFallbackProvider,
    getShowRemoteCursorElevation: getShowRemoteCursorElevation,
    getShowLocalCursorElevation: getShowLocalCursorElevation,
    getGridSnapEnabled: getGridSnapEnabled,
    setProvider: setProvider,
    setFallbackProvider: setFallbackProvider,
    setShowRemoteCursorElevation: setShowRemoteCursorElevation,
    setShowLocalCursorElevation: setShowLocalCursorElevation,
    setGridSnapEnabled: setGridSnapEnabled,
    buildTryOrder: buildTryOrder,
    initTracking: initTracking
  }
}

export {
  createMapCursorElevationController
}
